import $        from 'jquery';
/**
 * vClip 에 동적으로 그려질 템플릿 임폴트
 * !필독 : - 확장자명은 hbs로 되어있으나, 통검에서는 jsRender 로 그려짐으로 jsRender 로직을 사용하세요.
 */
import basicTypeTmpl from "./clip.hbs";
import innerListTypeTmpl from './clipInnerListType.hbs';

/**
 * vClip 함수의 기본 옵션값
 * !필독 : $context 의 기본값이 빈 스트링으로 지정되어 있으므로 기입이 되지 않는 다면 문제가 발생 할 수 있습니다.
 *        반드시 입력받을 것 (변수명의 접두사로 $ 를 가지고 있다면 제이쿼리 객체 이어야 합니다)
 *        listSelector 의 클래스명이 필요함, (ex 하이라이트 리스트의 ul className)
 * @type {{$context : string, listSelector : string, itemSelector : string, eventType : string, eventClassName : string,
 * vclipSelector : string, dataSelector : {date : string, hit : string, vid : string, link : string, desc : string}}}
 */
const DEF_OPTS = {
  $context:'', //필수
  listSelector:'', //필수
  itemSelector:'li',
  exceptClassName:'_no_vclip', // vclip 이 동작하지 않게 할 아이템의 클래스명
  eventType:'click',
  eventClassName:'on',
  removeSelector:'.vclip_sports',
  vclipSelector:'_vClipBox', // 아이디만 입력, #빼고 명칭만 기입
  dataSelector:{
    date:'date',
    hit:'hit',
    vid:'vid',
    link:'link',
    desc:'title',
  },
  rendingType:'basic', // 기본형 외부 랜더링 : basic & 확장됨 리스트내부 랜더링은 inner-list
  rowCount:0 // 한 열의 개수
};

/**
 * VideoClip 생성자 함수
 * 용도 : 하이라이트 영상 리스트 클릭시 발동되어 하이라이트 리스트 하단에 선택한 영상을 어팬드 해주는 모듈로 개발 되었습니다.
 * !필독 : 해당 모듈은 jQuery, jsRender, SF, KTP 가 사용됩니다. 참조 - http://hehet.dev.daum.net
 */
function VideoClip(options){
  this._options = $.extend({}, DEF_OPTS, options);
  this._$context = this._options.$context;
  this.init();
}


/**
 * 하이라이트 리스트에서 영상 아이탬 클릭시 해당 itemSelector 에 eventClassName 를 달아 주는 매서드
 * (다른 형제 요소들은 eventClassName 제거)
 * @param $currentItem
 */
VideoClip.prototype.onEventClass = function($currentItem){
  $currentItem.addClass(this._options.eventClassName).siblings().removeClass(this._options.eventClassName);
};
/**
 * 하이라이트 리스트에서 영상 아이템 클릭시 해당 itemSelector 에 걸려있는 eventClassName 제거
 * @param $currentItem
 */
VideoClip.prototype.offEventClass = function($currentItem){
  $currentItem.removeClass(this._options.eventClassName);
};
/**
 * kakao tv player 모듈을 로드해 주기 위한 모듈
 * 로드가 진행 되어야 동영상 재생이 가능합니다.
 * 참조 - http://hehet.dev.daum.net/modules/outapi/loadModule/kakaotv/index.html
 */
VideoClip.prototype.loadKTP = function(){
  SF.loadModule('kakaotv', function(status, module){});
};
/**
 * 동적으로 뿌려지는 동영상 영역 (vClip) 의 jsRender 탬플릿에 넘겨줄 데이터를 만들어 줍니다.
 * 백앤드 개발자와 해당 하는 부분의 데이터를 어떤식으로 전달 받을 것인지 협의가 필요합니다.
 * 동적인 부분으로 그려저야 할 데이터가 날짜,조회수,동영상 아이디,링크주소,설명 라고 했을경우
 * 하이라이트 리스트 itemSelector 부분에 data-hit,data-vid,data-link 등으로 전달 받는 것을 가정하고
 * desc 와 date 부분은 이미 하이라이트 영상 리스트에 노출이 됨으로 해당 부분에서 가져오는것으로 설정 되어 있습니다.
 * @param $target
 * @returns {{date, hit : string|*|void, vid, link, desc}}
 */
VideoClip.prototype.getVClipData = function($target){
  const dataSelector = this._options.dataSelector;
  // data 는 data-attr 를 참조하세요
  const vClipData = {
    date:$target.data(dataSelector.date),
    hit:$.number.addComma($target.data(dataSelector.hit)),
    vid:$target.data(dataSelector.vid),
    link:$target.data(dataSelector.link),
    desc:$target.data(dataSelector.desc),
  };
  return vClipData;
};

/**
 * jsRender 탬플릿과 getVClipData 를 통해서 지정된 데이터를 listSelector 즉 하이라이트 리스트의
 * 하단 부분에 붙혀주는 랜딩 메서드 입니다.
 *
 * 랜딩 타입이 추가되었습니다. 기본은 basic ( basic, inner-list ) = 현재까지는 두가지 종류가 있습니다.
 * @param data
 * @param rendingType
 * @param rendingIdx
 */
VideoClip.prototype.renderVClip = function(data, rendingType, rendingIdx){
  const type = rendingType || 'basic';
  const tmplMap = {
    'basic':basicTypeTmpl,
    'inner-list':innerListTypeTmpl
  };
  const tmpl = tmplMap[rendingType] || basicTypeTmpl;

  if(type === 'basic'){
    const html = $.templates(tmpl).render(data);
    this._$context.find(this._options.listSelector).after(html);
  }

  if(type === 'inner-list'){
    const html = $.templates(tmpl).render(data);
    const index = rendingIdx || 0;
    const $targetList = this._$context.find(this._options.listSelector).find(this._options.itemSelector+`[data-row='${index}']`);
    const $target = $targetList.eq($targetList.length-1 || 0);
    $target.after(html);
  }

};
/**
 * renderVClip 을 통해서 vClip 의 동적인 부분이 랜딩 되었다면,
 * KTP 모듈에 해당하는 video-id 를 넘겨서 영상을 생성해 주는 메서드입니다.
 * 참조 - http://wiki.daumkakao.com/display/keron/Player+IFrame+API
 * @param selectId
 * @param vid
 */
VideoClip.prototype.createVClip = function(selectId, vid){
  const playerContainer = document.getElementById(selectId);
  const clipLinkId = vid;
  const profile = 'HIGH';
  const playerConfig = {
    type:'VOD',
    service:'daum_searchview',
    id:clipLinkId + '@my',
    profile:profile,
    kakaotv:0,
    wmode:'opaque',
    fs:1
  };
  const player = KTP.Player.create(playerContainer, playerConfig);
  player.load(clipLinkId, profile);
};
/**
 * 동적으로 생성된 영역 (vClip) 부분을 제거 하는 메서드 입니다.
 */
VideoClip.prototype.removeVClip = function(){
  this._$context.find(`#${this._options.vclipSelector}`).parents(this._options.removeSelector).remove();
};
/**
 * 하이라이트 리스트의 이벤트 메서드 입니다.
 */
VideoClip.prototype.bindEvents = function(){
  const that = this;
  that._$context.find(that._options.listSelector).on(that._options.eventType, that._options.itemSelector, function(){
    const $this = $(this);
    if($this.hasClass(that._options.exceptClassName)){
      return;
    }
    that.removeVClip();
    if($this.hasClass(that._options.eventClassName)){
      that.offEventClass($this);
    }else{
      const clipData = that.getVClipData($this);
      const vid = $this.data(that._options.dataSelector.vid);
      that.onEventClass($this);
      that.renderVClip(clipData, that._options.rendingType, $this.data('row'));
      that.createVClip(that._options.vclipSelector, vid);
    }
  });
};

/**
 * data-row 라는 어트리뷰트를 삽입해 주는 함수이다.
 * rendingType = inner-list 인 상태에서만 사용
 * rendingType 이 inner-list 라면, 즉 리스트 내부로 클립이 삽입 되는 경우라면
 * 몇 번째 열 하단에 넣어야 하는지 몇번째 열인지 구분할 필요가 있다.
 * 여기서 data-row 는 해당하는 열의 가장 마지막에 있는 인덱스를 넣어준다.
 */
VideoClip.prototype.setRowData = function(){
  const that = this;
  const $targetList = that._$context.find(that._options.listSelector).find(that._options.itemSelector).not('#' + that._options.vclipSelector);

  let rowIdx = 0;

  $targetList.each(function(i, $el){
    if(i % that._options.rowCount === 0){
      rowIdx += (that._options.rowCount - 1);
    }
    $el.setAttribute('data-row', rowIdx);
  });
};
/**
 * 인스턴스 초기화 메서드입니다.
 */
VideoClip.prototype.init = function(){
  this.setRowData();
  this.loadKTP();
  this.bindEvents();
};

export default VideoClip;



/** WEBPACK FOOTER **
 ** ./src/sports/core/videoClip/index.js
 **/